import angular from "angular";

import BicyclesModuleRouting from "./bicycles.module.routing";

export default angular
    .module("vt-bicycles-public", [])
    .config(BicyclesModuleRouting);
